import React, { useContext, useEffect, useState } from "react";
import User_Info from "../../common_components/user_info/User_Info";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import { Form, Table } from "react-bootstrap";
import "./Child_Registration.css";
import { useDispatch, useSelector } from "react-redux";
import { Context } from "../../../utils/context";
import { AuthUpdateProfile } from "../../../features/auth/Slice";
import Users from "./Users/Users";
import { AllUsers } from "../../../features/user/Slice";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Child_Registration = () => {
  const dispatch = useDispatch();
  const { user, GetUser } = useContext(Context);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState("");

  const [userData, setUserData] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const users = useSelector((state) => state.user);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
    watch,
  } = useForm();

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const yourShare = watch("your_share");

  useEffect(() => {
    if (yourShare !== "" && yourShare !== undefined) {
      const myShare = Number(yourShare);

      if (myShare >= 0 && myShare <= 100) {
        setValue("share", 100 - myShare);
      }
    } else {
      setValue("share", "");
    }
  }, [yourShare, setValue]);

  const optionsTwo = [
    { value: "Need Pin", label: "Need Pin" },
    { value: "Need Password", label: "Need Password" },
    { value: "Need Both", label: "Need Both" },
  ];

  const onSubmit = async (data) => {
    console.log("Form Data: ", data);

    const result = await dispatch(AuthUpdateProfile(data));

    if (result.payload.success) {
      setSuccess("Created Successfully");
      reset();
      setErr("");
      await GetUser();
      await dispatch(AllUsers());
      setTimeout(() => {
        setSuccess("");
      }, 3000);
      clearErrors();
    } else {
      setErr(result.payload.errors);
      setTimeout(() => {
        setErr("");
      }, 3000);
    }
  };

  useEffect(() => {
    dispatch(AllUsers());
  }, []);

  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      reset({
        ...userData,
        pin: userData?.show_pin,
        password: userData?.show_password,
        confirm_password: userData?.show_password,
      });

      setShowPassword(true);
      setShowConfirmPassword(true);
    }
  }, [userData, reset]);

  return (
    <>
      <section className="Update_Profile Change_Password Child_Registration">
        <div className="user_info_div">
          <div className="row me-0 ms-0">
            <div className="col-lg-3 col-sm-8 col-12 my-3">
              <User_Info />
            </div>
          </div>
        </div>

        <div className="note_info_div">
          <div className="row me-0 ms-0">
            <div className="col-xxl-2 col-lg-3 col-md-6 order-lg-1 order-1 mb-2"></div>

            <div className="col-xxl-8 col-lg-6 col-md-12 order-lg-2 order-3 mb-2">
              {err && <div className="alert alert-danger">{err}</div>}
              {success && <div className="alert alert-success">{success}</div>}
              <div>
                <div className="manage_points_main_div mt-2">
                  <div className="title_div">
                    <p className="title_text">:: Child Registration</p>
                  </div>

                  <div className="update_form_div">
                    <Form>
                      <div className="row">
                        <div className="col-md-7">
                          <div className="inputs_div">
                            {/* <Form.Group
                              className="common_form_group"
                              controlId=""
                            >
                              <Form.Label>
                                <i class="fas fa-box-full    "></i> Name:
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="name"
                                placeholder="Enter Name"
                                {...register("name", {
                                  required: "Name is required",
                                })}
                              />
                            </Form.Group>
                            {errors.name && (
                              <sub className="text-danger">
                                {errors.name.message}
                              </sub>
                            )}
                            <Form.Group
                              className="common_form_group"
                              controlId=""
                            >
                              <Form.Label>User name:</Form.Label>
                              <Form.Control
                                type="text"
                                name="username"
                                placeholder="Enter User Name"
                                {...register("username", {
                                  required: "User Name is required",
                                })}
                              />
                            </Form.Group>
                            {errors.username && (
                              <sub className="text-danger">
                                {errors.username.message}
                              </sub>
                            )} */}

                            <Form.Group
                              className="common_form_group"
                              controlId=""
                            >
                              <Form.Label>
                                <i className="fas fa-envelope"></i> Email:
                              </Form.Label>
                              <Form.Control
                                type="email"
                                name="email"
                                placeholder="Enter Email"
                                {...register("email", {
                                  required: "Email is required",
                                })}
                              />
                            </Form.Group>

                            {errors.email && (
                              <sub className="text-danger">
                                {errors.email.message}
                              </sub>
                            )}

                            <Form.Group
                              className="common_form_group"
                              controlId="contact_no"
                            >
                              <Form.Label>
                                <i className="fas fa-phone"></i> Contact No:
                              </Form.Label>

                              <Form.Control
                                type="text"
                                inputMode="numeric"
                                maxLength={10}
                                name="contact_no"
                                placeholder="Enter Contact No"
                                {...register("contact_no", {
                                  required: "Contact No is required",
                                  pattern: {
                                    value: /^[0-9]{10}$/,
                                    message:
                                      "Mobile Number must be exactly 10 digits",
                                  },
                                  onChange: (e) => {
                                    e.target.value = e.target.value
                                      .replace(/\D/g, "")
                                      .slice(0, 10);
                                  },
                                })}
                              />
                            </Form.Group>

                            {errors.contact_no && (
                              <sub className="text-danger">
                                {errors.contact_no.message}
                              </sub>
                            )}

                            <Form.Group
                              className="common_form_group"
                              controlId=""
                            >
                              <Form.Label>
                                <i className="fas fa-key"></i> PIN:
                              </Form.Label>
                              <Form.Control
                                type="pin"
                                name="pin"
                                placeholder="Enter PIN"
                                {...register("pin", {
                                  required: "PIN is required",
                                  minLength: {
                                    value: 4,
                                    message:
                                      "PIN must be at least 6 characters",
                                  },
                                })}
                              />
                            </Form.Group>
                            {errors.pin && (
                              <sub className="text-danger">
                                {errors.pin.message}
                              </sub>
                            )}

                            <Form.Group
                              className="common_form_group"
                              controlId="password"
                            >
                              <Form.Label>
                                <i className="fas fa-key"></i> Password:
                              </Form.Label>
                              <div className="password_eye_field">
                                <Form.Control
                                  type={showPassword ? "text" : "password"}
                                  name="password"
                                  placeholder="Enter Password"
                                  {...register("password", {
                                    required: "Password is required",
                                    minLength: {
                                      value: 4,
                                      message:
                                        "Password must be at least 6 characters",
                                    },
                                  })}
                                />

                                <span
                                  className="password_eye_icon"
                                  onClick={() =>
                                    setShowPassword((prev) => !prev)
                                  }
                                >
                                  {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                              </div>
                            </Form.Group>

                            {errors.password && (
                              <sub className="text-danger">
                                {errors.password.message}
                              </sub>
                            )}

                            <Form.Group
                              className="common_form_group"
                              controlId="confirm_password"
                            >
                              <Form.Label>
                                <i className="fas fa-key"></i> Confirm Password:
                              </Form.Label>
                              <div className="password_eye_field">
                                <Form.Control
                                  type={
                                    showConfirmPassword ? "text" : "password"
                                  }
                                  name="confirm_password"
                                  placeholder="Enter Confirm Password"
                                  {...register("confirm_password", {
                                    required: "Confirm Password is required",
                                    validate: (value) =>
                                      value === getValues("password") ||
                                      "Passwords do not match",
                                  })}
                                />

                                <span
                                  className="password_eye_icon"
                                  onClick={() =>
                                    setShowConfirmPassword((prev) => !prev)
                                  }
                                >
                                  {showConfirmPassword ? (
                                    <FaEyeSlash />
                                  ) : (
                                    <FaEye />
                                  )}
                                </span>
                              </div>
                            </Form.Group>

                            {errors.confirm_password && (
                              <sub className="text-danger">
                                {errors.confirm_password.message}
                              </sub>
                            )}

                            <Form.Group className="common_form_group">
                              <Form.Label>
                                <i className="fas fa-key"></i> Share:
                              </Form.Label>

                              <Form.Control
                                type="number"
                                name="your_share"
                                placeholder="Enter Share"
                                {...register("your_share", {
                                  required: "Share is required",
                                  min: {
                                    value: 0,
                                    message: "Share cannot be less than 0",
                                  },
                                  max: {
                                    value: 100,
                                    message: "Share cannot be greater than 100",
                                  },
                                })}
                              />
                            </Form.Group>

                            {errors.your_share && (
                              <sub className="text-danger">
                                {errors.your_share.message}
                              </sub>
                            )}

                            <Form.Group className="common_form_group">
                              <Form.Label>
                                <i className="fas fa-key"></i> My Share:
                              </Form.Label>

                              <Form.Control
                                disabled
                                type="decimal"
                                name="share"
                                placeholder="Enter My Share"
                                readOnly
                                {...register("share", {
                                  required: "My Share is required",
                                })}
                              />
                            </Form.Group>

                            {errors.share && (
                              <sub className="text-danger">
                                {errors.share.message}
                              </sub>
                            )}
                            <div className="form_footer">
                              <div className="btn_holder">
                                <button
                                  className="blue_btn"
                                  type="button"
                                  onClick={handleSubmit(onSubmit)}
                                >
                                  Register
                                </button>
                              </div>
                              <div className="btn_holder">
                                <button className="blue_btn">Reset</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xxl-2 col-lg-3 col-md-6 order-lg-3 order-2 mb-2"></div>
          </div>
        </div>
      </section>

      <Users users={users} setUserData={setUserData} />
    </>
  );
};

export default Child_Registration;
